import { Component, ChangeDetectionStrategy } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { SharedModule } from '../../../@commons/ui-components/shared.module';
import { BaseToastComponent } from '../../../@commons/ui-components/toast-popup/base-toast-component';

@Component({
  selector: 'vw-climate-info-toast',
  standalone: true,
  imports: [SharedModule, TranslatePipe],
  templateUrl: './climate-info-toast.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './climate-info-toast.component.scss'
})
export class ClimateInfoToastComponent extends BaseToastComponent {
  constructor() {
    super();
  }
}
